import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { ListingArg } from './types';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/ListingCardClickstreamEvents.ts';

export const HOME_HUB_CARD_LOCATIONS = {
  savedSearch: 'saved_search_collection',
  similarToFavorite: 'similar_to_favorite_collection',
  similarToContacted: 'similar_to_contacted_collection',
  recentSearch: 'recent_search_collection',
  luxuryApartments: 'luxury_apartments_collection',
  affordableApartments: 'affordable_apartments_collection',
  promoApartments: 'promo_apartments_collection',
  popularApartments: 'popular_apartments_collection',
  recommendedSearch: 'recommended_search_collection',
  acceptsApplication: 'accepts_application_collection',
} as const;

export type ListingCardTriggerLocation =
  | (typeof HOME_HUB_CARD_LOCATIONS)[keyof typeof HOME_HUB_CARD_LOCATIONS]
  | 'search_results_feed'
  | 'search_results_list'
  | 'search_results_map'
  | 'similar_listings_module'
  | 'recently_viewed_listings_module'
  | 'portfolio_listings_module'
  | 'most_popular_rentals_nearby_module'
  | 'pet_friendly_rentals_nearby_module'
  | 'building_unit_card'
  | 'hp_homepage'
  | 'user_item_list_page'
  | 'user_item_viewed_page'
  | 'user_item_hidden_page';

const PROPERTY_CARD_IMPRESSION = defineHotpadsEvent({
  key: 'listing_card.impression',
  eventTypeId: '5601',
  eventTypeVersionId: '3',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackImpressionForPropertyCardEvent',
  trigger: {
    type: 'impression',
    location: 'search_results_list',
    source: 'property_card',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const CLICK_INTO_PROPERTY = defineHotpadsEvent({
  key: 'listing_card.click_into_property',
  eventTypeId: '9460',
  eventTypeVersionId: '4',
  eventTemplateId: '534',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackClicksIntoPropertyEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results_list',
    source: 'button_to_see_listing_details',
    object: 'property_card',
  },
  semanticEvent: 'clicks_into_property',
});

export function emitTrackImpressionForPropertyCardEvent({
  listing,
  triggerLocation,
}: ListingArg & { triggerLocation: ListingCardTriggerLocation }) {
  trackHotpadsEventDefinition(PROPERTY_CARD_IMPRESSION, { listing, triggerLocation });
}

export function emitTrackClicksIntoPropertyEvent({
  listing,
  triggerLocation,
}: ListingArg & { triggerLocation: ListingCardTriggerLocation }) {
  trackHotpadsEventDefinition(CLICK_INTO_PROPERTY, { listing, triggerLocation });
}
